import {Grid, TextField} from "@material-ui/core";
import {Field} from "formik";
import {fillAgentFormField} from "../store/agent-form.slice";
import React, {useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../../store";
import {useTranslation} from "react-i18next";
import useAuthority from "app/hooks/useAuthority";
import {ROLES} from "app/constants/roles";

const AgentEditInformation = () => {
  const dispatch = useDispatch();
  const agentForm = useSelector((state: AppState) => state.agents.agentForm);
  const {t} = useTranslation();
  const {hasUserAnyAuthority} = useAuthority();
  
  const isAdmin = hasUserAnyAuthority([ROLES.ROLE_ADMIN]);
  const isAgent = hasUserAnyAuthority([ROLES.ROLE_AGENT]) && !isAdmin;

  const handleChange = (e: any) => {
    const payload = {
      value: e.target.value,
      field: e.target.name
    }
    dispatch(fillAgentFormField(payload))
  }

  const re = useMemo(() => new RegExp("^[a-zA-Z ]*$"), []);
  // const [subAgentNameError, setSubAgentNameError] = useState("");
  // const [subAgentSurnameError, setSubAgentSurnameError] = useState("");

  // const validateSubAgentName = (e: any) => {
  //   setSubAgentNameError("");
  //   if (!e.target.value) setSubAgentNameError("Please enter the required field");
  //   else if (!re.test(e.target.value)) setSubAgentNameError("Only alphabets are allowed");
  // };

  // const validateSubAgentSurname = (e: any) => {
  //   setSubAgentSurnameError("");
  //   if (!e.target.value) setSubAgentSurnameError("Please enter the required field");
  //   else if (!re.test(e.target.value)) setSubAgentSurnameError("Only alphabets are allowed");
  // };

  return (
      <div>
        <Grid container spacing={4}>
          <Grid item xs={3}>
            <Field
                style={{width: '100%'}}
                label={t("app.main.agency.create.nameLastname", "Full Name")}
                onChange={handleChange}
                value={agentForm.fullName}
                variant='outlined'
                size='small'
                name='fullName'
                as={TextField}
                required
            />
          </Grid>
              <Grid item xs={3}>
            <Field
                style={{width: '100%'}}
                label={t("app.main.agency.create.nameLastname", "Agency Name")}
                onChange={handleChange}
                value={agentForm.agencyName}
                variant='outlined'
                size='small'
                name='agencyName'
                as={TextField}
                required
            />
          </Grid>
          <Grid item xs={3}>
            <Field
                style={{width: '100%'}}
                label={t("app.main.employees.employeeList.table.phoneNumber", "Phone number")}
                onChange={handleChange}
                value={agentForm.phoneNumber}
                variant='outlined'
                size='small'
                name='phoneNumber'
                as={TextField}
            />
          </Grid>
          <Grid item xs={3}>
            <Field
                type='email'
                style={{width: '100%'}}
                label={t("app.main.agency.create.email", "Contact E-mail")}
                onChange={handleChange}
                variant='outlined'
                value={agentForm.contactEmail}
                size='small'
                name='contactEmail'
                as={TextField}
                required
            />
          </Grid>
        </Grid>

        {/* {isAgent && (
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Field
                  style={{width: '100%'}}
                  label={t("app.main.agency.create.subAgentName", "Sub-Agent Name")}
                  onChange={(e: any) => {
                    handleChange(e);
                    validateSubAgentName(e);
                  }}
                  value={agentForm.subAgentName}
                  variant='outlined'
                  size='small'
                  name='subAgentName'
                  as={TextField}
                  required
              />
              {subAgentNameError && <span style={{ color: "red", display: "inline-block" }}>{subAgentNameError}</span>}
            </Grid>
            <Grid item xs={4}>
              <Field
                  style={{width: '100%'}}
                  label={t("app.main.agency.create.subAgentSurname", "Sub-Agent Surname")}
                  onChange={(e: any) => {
                    handleChange(e);
                    validateSubAgentSurname(e);
                  }}
                  value={agentForm.subAgentSurname}
                  variant='outlined'
                  size='small'
                  name='subAgentSurname'
                  as={TextField}
                  required
              />
              {subAgentSurnameError && <span style={{ color: "red", display: "inline-block" }}>{subAgentSurnameError}</span>}
            </Grid>
          </Grid>
        )} */}

        <Grid container spacing={4}>
          <Grid item xs={6}>
            <Field
                style={{width: '100%'}}
                label={t("app.main.agency.create.companyName", "Company Name")}
                onChange={handleChange}
                value={agentForm.companyName}
                variant='outlined'
                size='small'
                name='companyName'
                as={TextField}
                disabled={!isAdmin}
            />
          </Grid>
          <Grid item xs={6}>
            <Field
                style={{width: '100%'}}
                label={t("app.main.agency.create.location", "Location")}
                onChange={handleChange}
                value={agentForm.location}
                variant='outlined'
                size='small'
                name='location'
                as={TextField}
            />
          </Grid>
        </Grid>

        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Field
                style={{width: '100%'}}
                label={t("app.main.customer.customerList.address", "Address")}
                onChange={handleChange}
                value={agentForm.address}
                variant='outlined'
                size='small'
                name='address'
                as={TextField}
                multiline
                rows={4}
            />
          </Grid>
        </Grid>
      </div>
  )
}

export default AgentEditInformation;
